import { ID } from "@libs/interfaces/layouts";
import { IProject } from "../interfaces";

export default function getSchoolProjects (schoolId: ID, allProjectsList: IProject[] ) {
    let projects:IProject[] = [] 
    allProjectsList
        .filter((project: IProject) => {
            const school = project.fmru_school[0]
            return school?.id === schoolId
        })
        .forEach((project: IProject) => { 
            projects.push(project)
        }) 
    return projects 
}